export const isMontevideo = ({ description }) => {
  if (!description) return true

  return description.toLowerCase() === 'montevideo'
}
